import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { pw18_questions, pw18_scale } from '../variables/assessments/pw18.js'

import { calculateTimepoint1 } from '../../functions/timepoint.js'
import WarningIcon from '@material-ui/icons/Warning'
import Button from '@material-ui/core/Button'

import { baseline_steps } from '../variables/baseline.js'
import { trimonthly_steps } from '../variables/assessments.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepperAssm from './stepper_assm'
import { initAutosaveForForm, ensureAutosaveInitialized, detachAutosave } from '../../utils/draftAutosaveManager'

class Pw18 extends Component {
  constructor(props) {
    super(props)
    this.state = {
        status: 1,
        message: '',
        start_time: Math.floor(new Date().getTime()/1000),
        start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
        next_step: 'ders18',
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        q5: 0,
        q6: 0,
        q7: 0,
        q8: 0,
        q9: 0,
        q10: 0,
        q11: 0,
        q12: 0,
        q13: 0,
        q14: 0,
        q15: 0,
        q16: 0,
        q17: 0,
        q18: 0,
    }
    this.answerFields = Array.from({ length: 18 }, (_, i) => `q${i+1}`)
    this._draft = null
  }

  componentDidMount() {
    this._draft = initAutosaveForForm(this, {
       formId: 'gad7',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    })
    this.getAssmProcess()
  }

  componentDidUpdate(prevProps) {
    ensureAutosaveInitialized(this, '_draft', {
       formId: 'gad7',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    }, prevProps)
  }

  componentWillUnmount() {
    detachAutosave(this, '_draft')
  }

  getAssmProcess = () => {
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    if(timepoint == -1) {
      axios({
        method: 'post',
        url: connectNode + 'patient/assessment/get_baseline_process',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: { uid: this.props.authReducer.uid }
      })
      .then((result) => {
          if(result['data'] !== 'pw18') {
            this.props.history.push('/member/assessment/'+result['data']+'/'+type+'/'+timepoint)
          }
        }
      )
    } else if(timepoint == -2) {
      axios({
        method: 'post',
        url: connectNode + 'patient/assessment/get_assm_data',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          type: this.props.match.params.type,
          timepoint: this.props.match.params.timepoint,
          frm: 'pw18',
         }
      }).then((result) => {
        this.setState({
          status: 2,
          q1: result['data'].q1,
          q2: result['data'].q2,
          q3: result['data'].q3,
          q4: result['data'].q4,
          q5: result['data'].q5,
          q6: result['data'].q6,
          q7: result['data'].q7,
          q8: result['data'].q8,
          q9: result['data'].q9,
          q10: result['data'].q10,
          q11: result['data'].q11,
          q12: result['data'].q12,
          q13: result['data'].q13,
          q14: result['data'].q14,
          q15: result['data'].q15,
          q16: result['data'].q16,
          q17: result['data'].q17,
          q18: result['data'].q18,
        })
      })
    } else {
      if(type === 'tm') {
        axios({
          method: 'post',
          url: connectNode + 'patient/assessment/chk_each_assm',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            type: type,
            timepoint: timepoint,
            assm: 'patients_assessment_pw18',
           }
        }).then((result) => {
          var calTimepoint = calculateTimepoint1(result['data'].timeline_start)
          if(timepoint > calTimepoint.current_trimonth) {
            this.props.onLoadLocation('assessment_list_2', 'Sorry, something went wrong! Please only select available assessment in this page.')
            this.props.history.push('/member/assessment_list')
          } else if(timepoint == calTimepoint.current_trimonth || timepoint <= -9) {
            // Current timepoint => Fill the form //
            if(result['data'].step == null) {
              // Insert new row //
              axios({
                method: 'post',
                url: connectNode + 'patient/assessment/add_new_assm_process_wo_overview',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json;charset=UTF-8'
                },
                data: {
                  uid: this.props.authReducer.uid,
                  type: this.props.match.params.type,
                  timepoint: this.props.match.params.timepoint,
                  next_step: 'pw18',
                 }
              })
              .then((result) => {
                if(this.props.match.params.type == 'tm') {
                  this.setState({
                    next_step: 'providers',
                  })
                }
              })
            }

            if(result['data'].status !== null) {
              if(result['data'].assm_status == 1) {
                // Completed //
                this.getCompletedData(2)
              } else {
                if(result['data'].status == 1 && result['data'].step !== 'pw18') {
                  this.props.history.push('/member/assessment/'+result['data'].step+'/'+type+'/'+timepoint)
                } else if(result['data'].status == 1) {
                  if(this.props.match.params.type == 'tm') {
                    this.setState({ next_step: 'providers' })
                  } else {
                    this.setState({ next_step: 'complete_assessments' })
                  }
                }
              }
            }
          } else {
            // Past timepoint //
            this.getCompletedData(3)
          }
        })
      } else {
        this.props.onLoadLocation('assessment_list_2', 'Sorry, something went wrong! Please only select available assessment in this page.')
        this.props.history.push('/member/assessment_list')
      }
    }
  }

  getCompletedData = (status) => {
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    var next_step = "complete_assessments"
    if(timepoint <= -9 || timepoint > 0) {
      next_step = "providers"
    }
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: type,
        timepoint: timepoint,
        frm: 'pw18',
       }
    }).then((result) => {
      this.setState({
        status: status,
        next_step: next_step,
        q1: result['data'].q1,
        q2: result['data'].q2,
        q3: result['data'].q3,
        q4: result['data'].q4,
        q5: result['data'].q5,
        q6: result['data'].q6,
        q7: result['data'].q7,
        q8: result['data'].q8,
        q9: result['data'].q9,
        q10: result['data'].q10,
        q11: result['data'].q11,
        q12: result['data'].q12,
        q13: result['data'].q13,
        q14: result['data'].q14,
        q15: result['data'].q15,
        q16: result['data'].q16,
        q17: result['data'].q17,
        q18: result['data'].q18,
      })
    })
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);
    this.setState({ [name]: value }, () => {
      if (this.state.status === 1 && this._draft) {
        this._draft.savePartial(name, value, this.state);
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    var next_step = ''

    if(this.state.status === 1) {
      if(this.state.q1 === 0 || this.state.q2 === 0 || this.state.q3 === 0 ||
        this.state.q4 === 0 || this.state.q5 === 0 || this.state.q6 === 0 ||
        this.state.q7 === 0 || this.state.q8 === 0 || this.state.q9 === 0 ||
        this.state.q10 === 0 || this.state.q11 === 0 || this.state.q12 === 0 ||
          this.state.q13 === 0 || this.state.q14 === 0 || this.state.q15 === 0 ||
          this.state.q16 === 0 || this.state.q17 === 0 || this.state.q18 === 0) {
        this.setState({
          message: 'Please complete all items ',
        })
        window.scrollTo(0, 0)
      } else {
        axios({
          method: 'post',
          url: connectNode + 'patient/assessment/add_pw18',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
            timepoint: timepoint,
            type: type,
          }
        })
        .then((result) => {
          if(timepoint < 0 && timepoint >= -2) {
            if(result['data'] === 'ders18' || (type === 'y' && timepoint%4 === 0)) {
              this.props.onLoadLocation('/member/assessment/ders18/'+type+'/'+timepoint)
              this.props.history.push('/member/assessment/ders18/'+type+'/'+timepoint)
            }
          } else {
            if(type == 'tm'){
              next_step = 'providers'
            } else if(type == 'y') {
              next_step = 'ders18'
              type = 'y'
              timepoint = timepoint/4
            } else {
              next_step = 'complete_assessments'
            }
            if(result['data'] === 'complete_assessments' || type == 'tm') {
              if (this._draft) this._draft.clear()
              this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
              this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
            }
          }
        })
      }
    } else {
      if(timepoint == -2) {
        this.props.onLoadLocation('/member/assessment/psqi/'+type+'/'+timepoint)
        this.props.history.push('/member/assessment/psqi/'+type+'/'+timepoint)
      } else if(timepoint <= -9 || timepoint > 0) {
        var next_step = 'providers'
        if(type == 'tm'){
          next_step = 'providers'
        } else if(type == 'y') {
          next_step = 'ders18'
        }
        if (this._draft) this._draft.clear()
        this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
        this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
      } else {
        this.props.onLoadLocation('/member/assessment_list')
        this.props.history.push('/member/assessment_list')
      }
    }
  }

  render() {
    //console.log(this.props.match.params.timepoint)
    return (
      <div className="assm_pw18 box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Psychological Well-Being Scale (PWB)
          </div>
          {(this.props.match.params.timepoint < 0 && this.props.match.params.timepoint >= -2) &&
          <div className="small-12 columns stepper">
            <Stepper alternativeLabel nonLinear activeStep={5} >
              {baseline_steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>}
          {(this.props.match.params.timepoint <= -9 || this.props.match.params.timepoint > 0) &&
          <StepperAssm activeStep={6} assm={'PWB'} type={this.props.match.params.type}
            status={this.state.status} timepoint={this.props.match.params.timepoint} />}
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box2_2">
            <b>IMPORTANT: </b>
            If you cannot complete this section in one sitting, you may return and finish it <b>on this device</b> without losing your data.
          </div>
          <div className="small-12 columns box1">
            <div className="row show-for-medium bold">
              <div className="medium-5 columns">&nbsp;</div>
              {pw18_scale.map(each =>
                <div className="medium-1 columns headerResize2" key={'p'+each.value}>
                  {each.label}
                </div>
              )}
              <div className="small-12 columns">
                <div className="sep_line1">&nbsp;</div>
              </div>
            </div>
            <div className="scroll_y_2">
            {pw18_questions.map(eachQ =>
              <div className="row">
                <div className="small-12 medium-5 columns">
                  {eachQ.value}. {eachQ.label}
                </div>
                {pw18_scale.map(each =>
                  <div className="small-12 medium-1 columns" key={'pw'+eachQ.valuee+each.value}>
                    <input type="radio" name={"q"+eachQ.value}
                    checked={this.state["q"+eachQ.value] == each.value && 'checked'}
                    disabled={this.state.status > 1 && 'disabled'}
                    value={each.value} onChange={(e) => this.handleChange(e)}/>
                    <span className="show-for-small-only">{each.label}</span>
                  </div>
                )}
                {eachQ.value < 18 &&
                <div className="small-12 columns">
                  <div className="sep_line3">&nbsp;</div>
                </div>}
              </div>
            )}
            </div>
        </div>
        <div className="small-12 columns align_right">
          <Button variant="contained" color="primary" disableElevation
             onClick={this.handleSubmit} type="submit" className="submit_1">
              { this.state.status === 1 ? 'Submit' : 'Next' }
          </Button>
        </div>
      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Pw18)
